module.exports = __webpack_public_path__ + "static/media/about15.7729bb09.webp";